import {
  IAnalyticsRepository,
  IAnalyticsRepositoryParams,
  IDeductionsByRetailerRepositoryResponse,
} from "@/core/repositories/analytics";

export class GetDeductionsByRetailerUseCase {
  constructor(private readonly repo: IAnalyticsRepository) {}

  async execute(params: IAnalyticsRepositoryParams): Promise<IDeductionsByRetailerRepositoryResponse> {
    return this.repo.getDeductionsByRetailer(params);
  }
}
